
export const getWeatherDataReportsPending = () => {
    return {
        type: 'GET_WEATHER_DATA_REPORTS_PENDING'
    }
};

export const getWeatherDataReportsSuccess = (weatherDataReports) => {
    return {
        type: 'GET_WEATHER_DATA_REPORTS_SUCCESS',
        weatherDataReports,
    }
};

export const getWeatherDataReportsError = error => {
    return {
        type: 'GET_WEATHER_DATA_REPORTS_ERROR',
        error: error
    }
};


export const setWeatherDataReportsFilters = filters => {
    return {
        type: 'SET_WEATHER_DATA_REPORTS_FILTERS',
        filters: filters
    }
};

export const getWeatherDataReports = (filters) => {

    return dispatch => {
        dispatch(getWeatherDataReportsPending());

        fetch(`${process.env.REACT_APP_API_URL}/measurements/measurements_report`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({
                dateFrom: filters && filters.dateFrom ? filters.dateFrom : '',
                dateTo: filters && filters.dateTo ? filters.dateTo : '',
                numberOfDaysInPast: filters && filters.numberOfDaysInPast ? filters.numberOfDaysInPast : '',
                measurementsPeriodAggregation: filters && filters.measurementsPeriodAggregation ? filters.measurementsPeriodAggregation : '',
                weatherStationId: filters && filters.weatherStationId ? filters.weatherStationId : ''

            })
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json()
                } else {
                    dispatch(getWeatherDataReportsError(`Error: ${res.status} ${res.statusText}`))
                }
            })
            .then(res => {
                dispatch(getWeatherDataReportsSuccess(res))
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const downloadReport = (filters) => {

    return dispatch => {

        fetch(`${process.env.REACT_APP_API_URL}/measurements/measurements_report_export`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify({
                dateFrom: filters && filters.dateFrom ? filters.dateFrom : '',
                dateTo: filters && filters.dateTo ? filters.dateTo : '',
                numberOfDaysInPast: filters && filters.numberOfDaysInPast ? filters.numberOfDaysInPast : '',
                measurementsPeriodAggregation: filters && filters.measurementsPeriodAggregation ? filters.measurementsPeriodAggregation : '',
                weatherStationId: filters && filters.weatherStationId ? filters.weatherStationId : ''
            }),
        })
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `weather_report.csv`);
                document.body.appendChild(link);
                link.click();
                link.remove()
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const downloadWeatherStationPdf = (request) => {
    return () => {
        return fetch(`${process.env.REACT_APP_API_URL}/reports/weather-stations/pdf`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
                'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
            },
            body: JSON.stringify(request)
        })
            .then(async response => {
                if (!response.ok) {
                    const message = await response.text();
                    throw new Error(message || `${response.status} ${response.statusText}`);
                }

                const blob = await response.blob();
                const disposition = response.headers.get('Content-Disposition') || '';
                const filenameMatch = disposition.match(/filename="?([^"]+)"?/i);
                const filename = filenameMatch
                    ? filenameMatch[1]
                    : `weather-station-${request.weatherStationId}-${request.dateFrom}-${request.dateTo}.pdf`;
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            });
    };
};

